import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OwnerActionEventsEnum } from '../../../../interfaces/owner-action-event.enum';
import { CommunityItem } from '../../../../interfaces/community-item';
import { OwnerActionMenuService } from '../../../../services/util/owner-action-menu.service';
import { IconComponent } from '@outlaw/icons';

@Component({
  selector: 'app-owner-actions',
  templateUrl: './owner-actions.component.html',
  styleUrls: ['./owner-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class OwnerActionsComponent implements OnInit {
  @Input() item: CommunityItem;

  @Output() event: EventEmitter<OwnerActionEventsEnum> = new EventEmitter<OwnerActionEventsEnum>();
  isMenuOpen = false;

  get isPinnedPost(): boolean {
    return !!this.item.pinned_at;
  }

  get isSelfPost(): boolean {
    return this.item.post_type.slug === 'post';
  }

  private ownerActionMenuService = inject(OwnerActionMenuService);
  private elementRef = inject(ElementRef);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside && this.isMenuOpen) {
      this.closeMenu();
    }
  }

  ngOnInit(): void {
    this.ownerActionMenuService.userMenuIsOpenObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(isOpen => {
      if (!isOpen) {
        this.isMenuOpen = false;
        this.cdr.markForCheck();
      }
    });
  }

  openUserMenu(e: Event): void {
    e.stopPropagation();
    const anotherMenuIsOpen = this.ownerActionMenuService.userMenuIsOpen;

    this.ownerActionMenuService.toggleUserMenu();
    if (anotherMenuIsOpen) {
      this.ownerActionMenuService.toggleUserMenu();
    }

    this.isMenuOpen = this.ownerActionMenuService.userMenuIsOpen;
    this.cdr.markForCheck();
  }

  pinPost(e: Event): void {
    e.stopPropagation();
    this.event.emit(OwnerActionEventsEnum.pin);
    this.ownerActionMenuService.toggleUserMenu();
    this.isMenuOpen = this.ownerActionMenuService.userMenuIsOpen;
  }

  unpinPost(e: Event): void {
    e.stopPropagation();
    this.event.emit(OwnerActionEventsEnum.unpin);
    this.ownerActionMenuService.toggleUserMenu();
    this.isMenuOpen = this.ownerActionMenuService.userMenuIsOpen;
  }

  selectPost(e: Event): void {
    e.stopPropagation();
    this.ownerActionMenuService.toggleUserMenu();
    this.isMenuOpen = this.ownerActionMenuService.userMenuIsOpen;
  }

  editPost(e: Event): void {
    e.stopPropagation();
    this.event.emit(OwnerActionEventsEnum.edit);
    this.ownerActionMenuService.toggleUserMenu();
    this.isMenuOpen = this.ownerActionMenuService.userMenuIsOpen;
  }

  deletePost(e: Event): void {
    e.stopPropagation();
    this.event.emit(OwnerActionEventsEnum.delete);
    this.ownerActionMenuService.toggleUserMenu();
    this.isMenuOpen = this.ownerActionMenuService.userMenuIsOpen;
  }

  private closeMenu(): void {
    this.isMenuOpen = false;
    this.ownerActionMenuService.closeUserMenu();
    this.cdr.markForCheck();
  }
}
